export default __webpack_public_path__ + "static/media/logo.3565169d.svg";